import React, { useState } from 'react';
import { useTranslationContext } from "./project-builder-main.jsx";
import DeleteModal from './delete-modal.jsx';
import Checkbox from '@mui/material/Checkbox';


export default function AddedAttachmentsCard({ isSelectable, attachment, selectedAttachmentIds, setSelectedAttachmentIds }) {

    const { translations } = useTranslationContext();

    const [isDeleteOpen, setIsDeleteOpen] = useState(false);

    const openDeleteModal = () => setIsDeleteOpen(true);
    const closeDeleteModal = () => setIsDeleteOpen(false);

    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            setSelectedAttachmentIds(selectedAttachmentIds.concat(attachment.id))
        } else {
            setSelectedAttachmentIds(selectedAttachmentIds.filter(x => x !== attachment.id))
        }
    }

    return (
        <div key={attachment.id} className="col-md-6 mb-2">
            <div className="attachment-card rounded-border">
                {isSelectable &&
                    <Checkbox
                        key={attachment.id}
                        className="item-select"
                        onChange={(e) => handleCheckboxChange(e)}
                        checked={selectedAttachmentIds?.includes(attachment.id)}
                    inputProps={{
                        'aria-label': translations.Attachment,
                        }}
                    />
                }
                <div className="attachment-card-media" style={`background-image: url('${attachment.imageUrl}')`}>
                    <div className="attachment-card-media-overlay"></div>
                </div>
                <div className="attachment-card-content">
                    <div className="attachment-card-sku">{attachment.headline}</div>
                    <a href={attachment.linkUrl} className="attachment-card-title" target="_blank">{attachment.description}</a>
                </div>
                <button className="btn--delete" type="button" onClick={openDeleteModal}>
                    <span className="icon icon--trash"></span>
                    <DeleteModal isDeleteOpen={isDeleteOpen} closeDeleteModal={closeDeleteModal} attachment={attachment} />
                </button>
            </div>
        </div>
    )
}